"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rawTransactionV2 = void 0;
var ow_1 = __importDefault(require("ow"));
var big_js_1 = __importDefault(require("big.js"));
var tx_1 = require("@cosmjs/proto-signing/build/codec/cosmos/tx/v1beta1/tx");
var snakecaseKeys = __importStar(require("snakecase-keys"));
var codec_1 = require("../cosmos/v1beta1/codec");
var ow_types_1 = require("./ow.types");
var bytes_1 = require("../utils/bytes/bytes");
var secp256k1_1 = require("../utils/secp256k1");
var big_1 = require("../utils/big");
var types_1 = require("./types");
var clone_1 = require("../utils/clone");
var cosmosMsg_1 = require("./msg/cosmosMsg");
var ow_types_2 = require("../coin/ow.types");
var txDecoder_1 = require("../utils/txDecoder");
var v2_authInfo_1 = require("../utils/protoBuf/encoder/v2.authInfo");
var txBodyMessage_1 = require("../utils/protoBuf/encoder/txBodyMessage");
var v2_signable_1 = require("./v2.signable");
var utils_1 = __importDefault(require("../utils"));
exports.rawTransactionV2 = function (config) {
    return (function () {
        function RawTransactionV2() {
            this.txBody = {
                typeUrl: '/cosmos.tx.v1beta1.TxBody',
                value: {
                    messages: [],
                    memo: '',
                    timeoutHeight: '0',
                },
            };
            this.authInfo = {
                signerInfos: [],
                fee: {
                    gasLimit: new big_js_1.default(200000),
                },
            };
            this.signerAccounts = [];
            this.network = config.network;
        }
        RawTransactionV2.prototype.addMessage = function (message) {
            ow_1.default(message, 'message', cosmosMsg_1.owCosmosMsg());
            this.txBody.value.messages.push(message);
            return this;
        };
        RawTransactionV2.prototype.appendMessage = function (message) {
            return this.addMessage(message);
        };
        RawTransactionV2.prototype.toCosmosJSON = function () {
            var txObject = {
                body: Object.create({}),
                authInfo: Object.create({}),
                signatures: [],
            };
            try {
                var authInfoBytes = v2_authInfo_1.protoEncodeAuthInfoV2(this.getAuthInfo());
                var txBodyBytes = txBodyMessage_1.protoEncodeTxBody(this.getTxBody());
                var nativeAuthInfo = tx_1.AuthInfo.decode(authInfoBytes.toUint8Array());
                var nativeTxBody = tx_1.TxBody.decode(txBodyBytes.toUint8Array());
                txObject.authInfo = txDecoder_1.getAuthInfoJson(nativeAuthInfo);
                txObject.body = txDecoder_1.getTxBodyJson(nativeTxBody);
                var stringifiedTx = JSON.stringify(snakecaseKeys.default(txObject));
                var cosmosApiFormatTxJson = txDecoder_1.typeUrlToCosmosTransformer(stringifiedTx);
                return cosmosApiFormatTxJson;
            }
            catch (error) {
                throw new Error("error converting RawTransaction to Cosmos compatible JSON: " + error.toString());
            }
        };
        RawTransactionV2.prototype.exportSignerAccounts = function () {
            return JSON.stringify(this.getSignerAccounts().map(function (signerAccount) {
                return {
                    publicKey: signerAccount.publicKey.toBase64String(),
                    accountNumber: signerAccount.accountNumber.toString(),
                    signMode: signerAccount.signMode.toString(),
                };
            }));
        };
        RawTransactionV2.parseSignerAccounts = function (rawSignerAccounts) {
            ow_1.default(rawSignerAccounts, 'rawSignerAccounts', ow_1.default.string);
            var signerAccounts;
            try {
                signerAccounts = JSON.parse(rawSignerAccounts);
            }
            catch (err) {
                throw new Error("Invalid raw signer accounts: " + err.toString());
            }
            ow_1.default(signerAccounts, 'rawSignerAccounts', ow_1.default.array.ofType(ow_types_1.owRawSignerAccount()));
            return signerAccounts.map(function (account, i) {
                var publicKey;
                try {
                    publicKey = bytes_1.Bytes.fromBase64String(account.publicKey);
                }
                catch (err) {
                    throw new Error("Invalid signer account " + i + ": invalid public key " + err.toString());
                }
                var parsedSignMode = parseInt(account.signMode, 10);
                var signMode = types_1.getSignModeFromValue(parsedSignMode);
                if (!signMode) {
                    throw new Error("Invalid signer account " + i + ": invalid sign mode " + account.signMode);
                }
                return {
                    publicKey: publicKey,
                    accountNumber: new utils_1.default.Big(account.accountNumber),
                    signMode: signMode,
                };
            });
        };
        RawTransactionV2.prototype.setMemo = function (memo) {
            ow_1.default(memo, 'memo', ow_1.default.string);
            this.txBody.value.memo = memo;
            return this;
        };
        RawTransactionV2.prototype.setGasLimit = function (gasLimit) {
            ow_1.default(gasLimit, 'gasLimit', ow_1.default.string);
            try {
                this.authInfo.fee.gasLimit = new big_js_1.default(gasLimit);
            }
            catch (err) {
                throw new TypeError("Expected gasLimit value to be a base10 number represented as string, got `" + gasLimit + "`");
            }
            return this;
        };
        RawTransactionV2.prototype.setFee = function (fee) {
            ow_1.default(fee, 'fee', ow_types_2.owCoin());
            this.authInfo.fee.amount = [fee];
            return this;
        };
        RawTransactionV2.prototype.setFees = function (fees) {
            ow_1.default(fees, 'fees', ow_1.default.array.ofType(ow_types_2.owCoin()));
            this.authInfo.fee.amount = fees;
            return this;
        };
        RawTransactionV2.prototype.appendFeeAmount = function (feeAmount) {
            ow_1.default(feeAmount, 'feeAmount', ow_types_2.owCoin());
            if (typeof this.authInfo.fee.amount === 'undefined') {
                this.authInfo.fee.amount = [];
            }
            this.authInfo.fee.amount.push(feeAmount);
            return this;
        };
        RawTransactionV2.prototype.setTimeOutHeight = function (timeoutHeight) {
            ow_1.default(timeoutHeight, 'timeoutHeight', ow_types_1.owTimeoutHeight);
            this.txBody.value.timeoutHeight = timeoutHeight;
            return this;
        };
        RawTransactionV2.prototype.addSigner = function (signer) {
            ow_1.default(signer, 'signer', ow_types_1.owRawTransactionSigner);
            var publicKeyResult = secp256k1_1.isValidSepc256k1PublicKey(signer.publicKey);
            if (!publicKeyResult.ok) {
                throw new TypeError(publicKeyResult.err('signer'));
            }
            if (!big_1.isBigInteger(signer.accountNumber) && signer.accountNumber.gte(0)) {
                throw new TypeError("Expected accountNumber to be of positive integer, got `" + signer.accountNumber + "`");
            }
            if (!big_1.isBigInteger(signer.accountSequence) && signer.accountSequence.gte(0)) {
                throw new TypeError("Expected accountSequence to be of positive integer, got `" + signer.accountSequence + "`");
            }
            var signMode = signer.signMode;
            if (typeof signMode === 'undefined') {
                signMode = types_1.SIGN_MODE.DIRECT;
            }
            var cosmosSignMode;
            switch (signMode) {
                case types_1.SIGN_MODE.DIRECT:
                    cosmosSignMode = codec_1.cosmos.tx.signing.v1beta1.SignMode.SIGN_MODE_DIRECT;
                    break;
                case types_1.SIGN_MODE.LEGACY_AMINO_JSON:
                    cosmosSignMode = codec_1.cosmos.tx.signing.v1beta1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
                    break;
                default:
                    throw new Error("Unsupported sign mode: " + signMode);
            }
            this.authInfo.signerInfos.push({
                publicKey: signer.publicKey,
                modeInfo: {
                    single: {
                        mode: cosmosSignMode,
                    },
                },
                sequence: signer.accountSequence,
            });
            this.signerAccounts.push({
                publicKey: signer.publicKey,
                accountNumber: signer.accountNumber,
                signMode: signMode,
            });
            return this;
        };
        RawTransactionV2.prototype.toSignable = function () {
            if (this.authInfo.signerInfos.length === 0) {
                throw new Error('Expected signer in transaction, got none');
            }
            if (this.txBody.value.messages.length === 0) {
                throw new Error('Expected message in transaction, got none');
            }
            return new v2_signable_1.SignableTransactionV2({
                rawTxJSON: this.toCosmosJSON(),
                network: clone_1.cloneDeep(this.network),
                signerAccounts: clone_1.cloneDeep(this.signerAccounts),
            });
        };
        RawTransactionV2.prototype.getTxBody = function () {
            return this.txBody;
        };
        RawTransactionV2.prototype.getAuthInfo = function () {
            return this.authInfo;
        };
        RawTransactionV2.prototype.getNetwork = function () {
            return this.network;
        };
        RawTransactionV2.prototype.getSignerAccounts = function () {
            return this.signerAccounts;
        };
        return RawTransactionV2;
    }());
};
//# sourceMappingURL=v2.raw.js.map